<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="举报编号">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="举报类型">
            <a-tag :color="getReportTypeColor(detailData.reportType)">
              {{ getReportTypeText(detailData.reportType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="处理状态">
            <a-tag :color="detailData.reportProcessing === 1 ? 'green' : 'orange'">
              {{ detailData.reportProcessing === 1 ? '已处理' : '待处理' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="举报文章类型">
            {{ detailData.reportArticleType === 0 ? '文章' : '评论文章' }}
          </a-descriptions-item>
          <a-descriptions-item label="文章/评论编号">{{ detailData.reportArticleId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="文章/评论名称">{{ detailData.reportArticleName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="举报用户ID">{{ detailData.creator || '-' }}</a-descriptions-item>
          <a-descriptions-item label="举报用户名称">{{ detailData.userName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="举报用户手机号">{{ detailData.userMobile || '-' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '-' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="举报说明" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item>
            <div class="content-wrapper">{{ detailData.reportExplain || '--' }}</div>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="备注" :column="1" bordered style="margin-top: 16px" v-if="detailData.remark">
          <a-descriptions-item>
            <div class="content-wrapper">{{ detailData.remark || '--' }}</div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getReport } from '@/api/tutorial/report'
import { message } from 'ant-design-vue'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
    }
  },
  computed: {
    title() {
      return '举报详情'
    },
  },
  methods: {
    show(record) {
      this.visible = true
      this.loadDetail(record.id)
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getReport(id)
        if (response && (response.code === '20001' || response.success)) {
          this.detailData = response.data || {}
        } else {
          message.error(response.message || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    getReportTypeText(type) {
      const typeMap = {
        0: '广告软文',
        1: '标题党',
        2: '内容低俗',
        3: '抄袭侵权',
        4: '其它问题',
      }
      return typeMap[type] || '--'
    },
    getReportTypeColor(type) {
      const colorMap = {
        0: 'red',
        1: 'orange',
        2: 'purple',
        3: 'blue',
        4: 'grey',
      }
      return colorMap[type] || 'grey'
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.content-wrapper {
  max-height: 400px;
  overflow-y: auto;
  word-wrap: break-word;
}

.ant-descriptions {
  margin-bottom: 0;
}
</style>
